import { SvgProps } from './types'

export const ConsortiumIcon = ({ color, className, width = '40', height = '40' }: SvgProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M21.6667 35H35" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
    <path
      d="M21.6667 26.667 15.8333 20.8337 10 15.0003m5.8333 5.8334L3.3333 33.3337M8.3333 16.667 10 15.0003l6.6667-6.66664L18.3333 6.667m-1.6666 1.66666L28.3333 20.0003M30 18.3337l-1.6667 1.6666-6.6666 6.6667L20 28.3337"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
